import { createFileRoute } from "@tanstack/react-router";
import { VendorDemoEinstellungenPage } from "@/components/vendor/VendorDemoEinstellungenPage";

export const Route = createFileRoute("/vendor/demo-einstellungen")({
  head: () => ({
    meta: [{ title: "Demo-Daten-Einstellungen · Pulse Vendor" }],
  }),
  component: VendorDemoEinstellungenPage,
});
